import {Map} from 'immutable';

import {type ActivityEmbed} from 'web-app/react/feed/post/embeds/activities';
import * as NonEmptyArray from 'web-app/util/non-empty-array';
import {hasValue} from 'web-app/util/typescript';
import {type ActivityLink} from 'web-app/react/modals-container/activities-modal/types';

const isActivityEmbed = (embed: Map<any, any>): embed is ActivityEmbed => embed.get('type') === 'activities';

/**
 * Because the backend strips away the activity URLs from the body
 * we have to stitch it back together when sending a post/draft to keep
 * them in the data-flow
 *
 * Hacky but it works for now.
 */

export const addActivitiesToBody = (body: string, activities?: ActivityLink[] | null) =>
    [body, ...(activities || []).map(({url}) => url)].join('\n\n');

export const embedToActivityFormValues = (embed?: Map<any, any>) => {
    if (!hasValue(embed) || !isActivityEmbed(embed)) {
        return [];
    }
    return embed.get('links');
};

export const activityLinksToEmbed = (links?: ActivityLink[]): undefined | ActivityEmbed => {
    if (hasValue(links) && NonEmptyArray.isNonEmpty(links)) {
        return Map({
            type: 'activities',
            links,
        });
    }
    return undefined;
};
